<template>
  <v-container id="requisicoes" fill-height fluid grid-list-xl tag="section">
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            :timeout="timeout"
            top
          >
            {{ textSnackbar }}
            <v-btn
              class="mx-2"
              fab
              small
              color="white"
              text
              @click="snackbar = false"
              dark
            >
              <v-icon dark>mdi-close-thick</v-icon>
            </v-btn>
          </v-snackbar>
        </div>
        <v-card>
          <div>
            <v-dialog v-model="loading" hide-overlay persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Buscando informações, aguarde ...
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>

          <FiltroIntervaloData
            v-on:add-filtro-intervalo-data="buscarAsRequisicoes"
          ></FiltroIntervaloData>
          <EstatisticasRequisicoes />

          <v-card v-if="totalizadoresReq.length" class="mx-auto text-center">
            <v-container fluid>
              <v-row dense>
                <v-col v-for="total in totalizadoresReq" :key="total.title">
                  <v-card>
                    <v-card-title
                      class="justify-center"
                      v-text="total.title"
                    ></v-card-title>
                    <v-card-text>
                      <v-chip class="ma-2" color="green" text-color="white">{{
                        total.value | dinheiro
                      }}</v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-card-title>
            Requisições
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
            <v-dialog
              v-model="dialogRequisicao"
              max-width="950px"
              @keydown.esc="aoFecharDialogRequisicao"
            >
              <Requisicao />
            </v-dialog>
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="requisicoes"
            :search="search"
            :items-per-page="25"
            sort-by="['cdfil','nrrqu','serier']"
            sort-desc
            multi-sort
            item-key="id"
            class="elevation-3"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                small
                color="primary"
                class="mr-0"
                @click="visualizarRequisicao(item)"
                >mdi-monitor-eye</v-icon
              >
            </template>
            <template v-slot:[`item.requisicao`]="{ item }">{{
              `${item.nrrqu}${item.serier}`
            }}</template>
            <template v-slot:[`item.prcusto`]="{ item }">{{
              item.prcusto | dinheiro
            }}</template>
            <template v-slot:[`item.prvenda`]="{ item }">{{
              item.prvenda | dinheiro
            }}</template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FiltroIntervaloData from "../components/filtros/FiltroIntervaloData";
import EstatisticasRequisicoes from "../views/EstatisticasRequisicoes";
import { mapActions } from "vuex";
import Requisicao from "../views/Requisicao";

export default {
  components: {
    FiltroIntervaloData,
    Requisicao,
    EstatisticasRequisicoes,
  },
  props: ["chartDataRequisicoesCanalQtde", "chartDataRequisicoesCanalValor"],
  data: () => ({
    headers: [
      { text: "", value: "action", sortable: false, width: 1 },
      { text: "Lj", align: "start", sortable: true, value: "cdfil", width: 1 },
      { text: "Req.", align: "start", sortable: true, value: "nrrqu" },
      { text: "Sr", align: "start", sortable: true, value: "serier" },
      { text: "Emissão", align: "start", sortable: true, value: "dtcad" },
      { text: "Cliente", align: "start", sortable: true, value: "nomecli" },
      { text: "Custo", align: "end", sortable: true, value: "prcusto" },
      { text: "Fator", align: "end", sortable: true, value: "fatorV" },
      { text: "Valor", align: "end", sortable: true, value: "prvenda" },
    ],
    pagination: {
      descending: true,
    },
    requisicoes: [],
    totalizadoresReq: [],
    dialogRequisicao: false,
    search: "",
    loading: false,
    errored: false,
    snackbar: false,
    textSnackbar: "",
    snackbarColor: "",
    timeout: 10000,
    requisicaoSelecionada: [],
    estatisticasPorCanal: [],
    estatisticasPorLoja: [],
    estatisticasPorTipoCliente: [],
  }),

  created() {
    if (!this.requisicoes.length) {
      this.$store.dispatch("adicionarEstatisticaRequisicoes", null);
      this.$store.dispatch("adicionarEstatisticaRequisicoesPorLoja", null);
      this.$store.dispatch(
        "adicionarEstatisticaRequisicoesPorTipoCliente",
        null
      );
    }
  },
  computed: {},
  watch: {},
  methods: {
    buscarAsRequisicoes(datas) {
      this.loading = true;
      this.$http
        .get("requisicoes", {
          params: {
            dataInicial: datas.dataDeInicio,
            dataFinal: datas.dataDeFim,
          },
        })
        .then((res) => {
          if (res.data.listaRequisicoes.length) {
            this.requisicoes = res.data.listaRequisicoes;
            this.totalizadoresReq = res.data.totalizadoresReq;
            this.estatisticasPorCanal = [];
            this.estatisticasPorCanal.push(
              res.data.chartReqCanalQtde,
              res.data.chartReqCanalValor,
              res.data.totalPorCanalReq
            );
            this.estatisticasPorLoja = [];
            this.estatisticasPorLoja.push(
              res.data.chartReqLojaQtde,
              res.data.chartReqLojaValor,
              res.data.totalPorLojaReq
            );
            this.estatisticasPorTipoCliente = [];
            this.estatisticasPorTipoCliente.push(
              res.data.chartReqTipoClienteQtde,
              res.data.chartReqTipoClienteValor,
              res.data.totalPorTipoCliente
            );
            this.adicionarEstatisticas();
          } else {
            this.textSnackbar = "Não há dados para o período.";
            this.snackbar = true;
            this.snackbarColor = "info";
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    ...mapActions([
      "adicionarFiltroRequisicao",
      "adicionarEstatisticaRequisicoes",
      "adicionarEstatisticaRequisicoesPorLoja",
      "adicionarEstatisticaRequisicoesPorTipoCliente",
    ]),
    adicionarEstatisticas() {
      this.$store.dispatch(
        "adicionarEstatisticaRequisicoes",
        this.estatisticasPorCanal
      );
      this.$store.dispatch(
        "adicionarEstatisticaRequisicoesPorLoja",
        this.estatisticasPorLoja
      );
      this.$store.dispatch(
        "adicionarEstatisticaRequisicoesPorTipoCliente",
        this.estatisticasPorTipoCliente
      );
    },
    aoFecharDialogRequisicao() {
      this.dialogRequisicao = false;
    },
    visualizarRequisicao(item) {
      const requisicaoSelecionada = [
        `${item.cdfil}`,
        `${item.nrrqu}`,
        `${item.serier}`,
      ];
      this.$store.dispatch("adicionarFiltroRequisicao", requisicaoSelecionada);
      this.dialogRequisicao = true;
    },
  },
};
</script>

<style>
</style>